import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'

import Header from '../components/Header/Header.js'
import Footer from '../components/Footer/Footer.js'
import Button from '../components/Button/Button.js'
import CustomField from '../components/CustomField/CustomField.js'
import Tabs from '../components/Tabs/Tabs.js'
import Checkbox from '../components/Checkbox/Checkbox.js'

import TestForm from '../components/_TestComponents/TestForm.js'

import { showTooltip, hideTooltip } from '../actions/actions.export.js';

class StyleGuide extends Component {
  constructor(props){
    super(props);

    this.state = {
      tab1: 1
    }  
  }

  render(){
    const { dispatch, user } = this.props;

    return <div className="landing">
      <div className="screen-height-container">
        <div className="shc-background translucent">
          
        </div>
        <div className="shc-content">
          <Header transparent={true}/>
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h1>Heading 1</h1>
                <h2>Heading 2</h2>
                <h3>Heading 3</h3>
                <h4>Heading 4</h4>
                <h5>Heading 5</h5>
                <hr/>
                
                <p className="lead">
                  Lead text sentence ahead of something.
                </p>
                
                <p>
                  Paragraph of text Paragraph of text Paragraph of text Paragraph of text Paragraph of text Paragraph of text Paragraph of text Paragraph of text Paragraph of text Paragraph of text Paragraph of text Paragraph of text Paragraph of text Paragraph of text Paragraph of text Paragraph of text Paragraph of text Paragraph of text Paragraph of text Paragraph of text Paragraph of text Paragraph of text Paragraph of text Paragraph of text Paragraph of text Paragraph of text Paragraph of text Paragraph of text Paragraph of text Paragraph of text Paragraph of text Paragraph of text Paragraph of text Paragraph of text Paragraph of text Paragraph of text Paragraph of text Paragraph of text Paragraph of text Paragraph of text.
                </p>

                <small>Smaller text.</small>
                
                <br/><br/>

                <Link to="/">Text Link</Link>

                <br/><br/>

                <ul className="list-bulleted">
                  <li>Unordered list item 1</li>
                  <li>Unordered list item 2</li>
                  <li>Unordered list item 3</li>
                </ul>

                <ol>
                  <li>Ordered list item 1</li>
                  <li>Ordered list item 2</li>
                  <li>Ordered list item 3</li>
                </ol>

                <ul className="list-divided">
                  <li>Unordered list item 1</li>
                  <li>Unordered list item 2</li>
                  <li>Unordered list item 3</li>
                </ul>

              </div>

              <div className="col-md-12">
                <div className="list-left">
                  <div className="color-swatch bg-primary"/>
                  <div className="color-swatch bg-secondary"/>
                  <div className="color-swatch bg-success"/>
                  <div className="color-swatch bg-warning"/>
                  <div className="color-swatch bg-danger"/>
                </div>
                <div className="list-left">
                  <div className="color-swatch bg-gs0">
                    <div className="color-swatch-inner">
                      0
                    </div>
                  </div>
                  <div className="color-swatch bg-gs1">
                    <div className="color-swatch-inner">
                      1
                    </div>
                  </div>
                  <div className="color-swatch bg-gs2">
                    <div className="color-swatch-inner">
                      2
                    </div>
                  </div>
                  <div className="color-swatch bg-gs3">
                    <div className="color-swatch-inner">
                      3
                    </div>
                  </div>
                  <div className="color-swatch bg-gs4">
                    <div className="color-swatch-inner">
                      4
                    </div>
                  </div>
                  <div className="color-swatch bg-gs5">
                    <div className="color-swatch-inner">
                      5
                    </div>
                  </div>
                  <div className="color-swatch bg-gs6">
                    <div className="color-swatch-inner">
                      6
                    </div>
                  </div>
                  <div className="color-swatch bg-gs7">
                    <div className="color-swatch-inner">
                      7
                    </div>
                  </div>
                  <div className="color-swatch bg-gs8">
                    <div className="color-swatch-inner">
                      8
                    </div>
                  </div>
                  <div className="color-swatch bg-gs9">
                    <div className="color-swatch-inner">
                      9
                    </div>
                  </div>
                  <div className="color-swatch bg-gs10">
                    <div className="color-swatch-inner">
                      10
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-12">
                <div className="list-left list-padded">
                  <Button display="Default"/>
                  <Button display="Small" size="small"/>
                  <Button display="Medium" size="medium"/>
                  <Button display="Large" size="large"/>
                </div>
              </div>

              <div className="col-md-12">
                <Button display="Block" block={true} size="large"/>
              </div>


              <div className="col-md-12">
                <div className="list-left list-padded">
                  <Button display="Disabled" disabled={true}/>
                  <Button display="Thinking" thinking={true}/>
                  <Button display="Click to Test" onClick={(e)=>{ this.setState({ buttonTime: new Date().getTime() })}}/>
                  <Button display="Successful" successful={this.state.buttonTime}/>
                  <Button display="Failed" failed={this.state.buttonTime}/>
                  <Button display="Successful" color="success" successful={this.state.buttonTime}/>
                  <Button display="Failed" color="success" failed={this.state.buttonTime}/>
                </div>
              </div>

              <div className="col-md-12">
                <div className="list-left list-padded">
                  <Button display="Grey" color="grey"/>
                  <Button display="Success" color="success"/>
                  <Button display="Danger" color="danger"/>
                  <Button display="Primary" color="primary"/>
                  <Button display="Secondary" color="secondary"/>
                  <Button display="Grey Danger" color="grey-danger"/>
                </div>
              </div>

              <div className="col-md-12">
                <div className="list-left list-padded">
                  <span className="list-item">
                    <Button display="Get Started Now" color="secondary" size="large"/>
                  </span>
                  <span className="list-item">
                    <Button display={<span> <i className="fas fa-play fa-small"/>&nbsp;&nbsp;&nbsp;Watch Video</span>} size="large"/>
                  </span>
                </div>
              </div>

            </div>
            <form name="StyleGuideForm">
              <div className="row">
                <div className="col-md-4">
                  <CustomField 
                    type="text"
                    name="basic"
                    placeholder="basic input"
                    label="Basic"
                    description="This is a simple description."
                    value={this.state.basic}
                    onChange={(e) => {this.setState({basic: e}); }}
                  />
                </div>

                <div className="col-md-4">
                  <CustomField 
                    type="number"
                    name="basic"
                    placeholder="basic number input"
                    label="Basic Numeric"
                    description="This is a simple description."
                    value={this.state.basicNumber}
                    onChange={(e) => {this.setState({basicNumber: e}); }}
                  />
                </div>

                <div className="col-md-4">
                  <CustomField 
                    type="text"
                    name="required"
                    placeholder="required input"
                    label="Required"
                    value={this.state.required}
                    onChange={(e) => {this.setState({required: e}); }}
                    required={true}
                  />
                </div>

                <div className="col-md-4">
                  <CustomField 
                    type="text"
                    regex="email"
                    name="email"
                    placeholder="email address"
                    label="Email"
                    value={this.state.email}
                    onChange={(e) => {this.setState({email: e}); }}
                    serverErrors={user.loginForm.errors.email}
                  />
                </div>


                <div className="col-md-4">
                  <CustomField 
                    type="password"
                    name="password"
                    label="Password"
                    value={this.state.password}
                    onChange={(e) => {this.setState({password: e}); }}
                    serverErrors={user.loginForm.errors.password}
                    required={true}
                  />
                </div>


                <div className="col-md-4">
                  <CustomField 
                    type="test"
                    name="hasServerErrors"
                    label="Has Server Errors"
                    value={this.state.hasServerErrors}
                    onChange={(e) => {this.setState({hasServerErrors: e}); }}
                    serverErrors={"Custom server error message here."}
                  />
                </div>


                <div className="col-md-4">
                  <CustomField 
                    type="test"
                    name="minMaxLength"
                    label="Min & Max Length"
                    value={this.state.minMaxLength}
                    onChange={(e) => {this.setState({minMaxLength: e}); }}
                    minLength={5}
                    maxLength={10}
                  />
                </div>

                <div className="col-md-4">
                  <CustomField 
                    type="test"
                    name="hasServerErrorsAndDescription"
                    label="Has Server Errors & Description"
                    description="This description forces our error to a tooltip."
                    value={this.state.hasServerErrors}
                    onChange={(e) => {this.setState({hasServerErrors: e}); }}
                    serverErrors={"Custom server error message here."}
                  />
                </div>

                <div className="col-md-4">
                  <CustomField 
                    type="text"
                    multipleRows={true}
                    name="basicmultiline"
                    placeholder="basic multipleRows input"
                    label="Basic MultipleRows"
                    description="This is a simple description."
                    value={this.state.basic}
                    onChange={(e) => {this.setState({basic: e}); }}
                  />
                </div>


                <div className="col-md-4">
                  <CustomField 
                    type="text"
                    multipleRows={true}
                    minRows={5}
                    name="basicmultiline"
                    placeholder="basic multipleRows input w/ 5 minRows"
                    label="Basic MultipleRows w/ 5 minRows"
                    description="This is a simple description."
                    value={this.state.basic}
                    onChange={(e) => {this.setState({basic: e}); }}
                  />
                </div>

              </div>

              <div className="row">
                <div className="col-md-12">
                  <div className="list-left list-padded">
                    <Checkbox value={this.state.checkbox} onToggle={(e) => { this.setState({checkbox: !this.state.checkbox})}}/>
                    <span>Simple checkbox</span>
                  </div>
                  <div className="list-left list-padded">
                    <Checkbox switch={true} value={this.state.checkbox} onToggle={(e) => { this.setState({checkbox: !this.state.checkbox})}}/>
                    <span>Simple checkbox switch variation</span>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="list-left list-padded">
                    <Tabs
                      items={[
                          {
                            value: 1,
                            display: "1"
                          },
                          {
                            value: 2,
                            display: "2"
                          },
                          {
                            value: 3,
                            display: "3"
                          }
                        ]}
                      value={this.state.tab1}
                      size="small"
                      onChange={(e)=>{this.setState({tab1: e.value})}}
                    />
                    <Tabs
                      items={[
                          {
                            value: 1,
                            display: "1"
                          },
                          {
                            value: 2,
                            display: "2"
                          },
                          {
                            value: 3,
                            display: "3"
                          }
                        ]}
                      value={this.state.tab1}
                      size="medium"
                      onChange={(e)=>{this.setState({tab1: e.value})}}
                    />
                    <Tabs
                      items={[
                          {
                            value: 1,
                            display: "1"
                          },
                          {
                            value: 2,
                            display: "2"
                          },
                          {
                            value: 3,
                            display: "3"
                          }
                        ]}
                      value={this.state.tab1}
                      size="large"
                      onChange={(e)=>{this.setState({tab1: e.value})}}
                    />
                  </div>
                </div>
              </div>
            </form>
            <div className="row">
              <div className="col-md-4">
                <div className="col-themed">
                  <h3>H3 Title</h3>
                  <p className="lead">
                    A short lead description line that isn't too too long.
                  </p>
                  <Link to="/" className="col-themed-link">col-themed-link</Link>
                </div>
              </div>
              <div className="col-md-4">
                <div className="col-themed">
                  <span class="fa-stack fa-lg fa-stack-fix-left-margin text-primary col-themed-icon">
                    <i class="fas fa-circle fa-stack-2x"></i>
                    <i class="fas fa-flag fa-stack-1x fa-inverse"></i>
                  </span>
                  <h3>H3 Title</h3>
                  <p className="lead">
                    A short lead description line that isn't too too long.
                  </p>
                  <Link to="/" className="col-themed-link">col-themed-link</Link>
                </div>
              </div>
              <div className="col-md-4">
                <div className="col-themed">
                  col-themed
                </div>
              </div>
            </div>
          </div>
        </div> 
      </div>
      <Footer/>
    </div>
  }
}

StyleGuide = reduxForm({
  form: 'StyleGuideForm',
  enableReinitialize: true,
  destroyOnUnmount: false
})(StyleGuide)

const mapStateToProps = (state) => {
  const { user } = state;

  return {
    user
  }
}

export default connect(mapStateToProps)(StyleGuide);



// WEBPACK FOOTER //
// ./src/routes/StyleGuide.js